import { type V2 } from "@project-rouge/rg-core";

export function GetLinesFromPolygon(polygon: V2[]): [V2, V2][] {
  const lines: [V2, V2][] = [];
  for (let i = 0; i < polygon.length - 1; i++) {
    lines.push([polygon[i], polygon[i + 1]]);
  }
  return lines;
}
